import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    // Check for admin token first, then regular token
    const token = localStorage.getItem('admin_token') || localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getCurrentUser: () => api.get('/auth/me'),
};

// Product APIs
export const productAPI = {
  getProducts: (params) => api.get('/products', { params }),
  getProduct: (id) => api.get(`/products/${id}`),
  getCategories: () => api.get('/categories'),
  getBrands: () => api.get('/brands'),
};

// Cart APIs
export const cartAPI = {
  getCart: (sessionId) => api.get('/cart', { headers: { 'session-id': sessionId } }),
  addToCart: (data, sessionId) => api.post('/cart/add', data, { headers: { 'session-id': sessionId } }),
  updateCartItem: (index, data, sessionId) => api.put(`/cart/update/${index}`, data, { headers: { 'session-id': sessionId } }),
  removeFromCart: (index, sessionId) => api.delete(`/cart/remove/${index}`, { headers: { 'session-id': sessionId } }),
  clearCart: (sessionId) => api.delete('/cart/clear', { headers: { 'session-id': sessionId } }),
};

// Order APIs
export const orderAPI = {
  createOrder: (data) => api.post('/orders', data),
  getOrders: (params) => api.get('/orders', { params }),
  getOrder: (orderNumber) => api.get(`/orders/${orderNumber}`),
};

// Vehicle APIs
export const vehicleAPI = {
  getMakes: () => api.get('/vehicles/makes'),
  getModels: (makeId) => api.get('/vehicles/models', { params: { make_id: makeId } }),
  getYears: () => api.get('/vehicles/years'),
  getCompatibleProducts: (params) => api.get('/vehicles/compatible-products', { params }),
};

export default api;
